// Main Application JavaScript
document.addEventListener('DOMContentLoaded', function() {
  
  // Initialize all components
  initSmoothScrolling();
  initLanguageSwitcher();
  initFormValidation();
  initLazyLoading();
  initPerformanceOptimizations();
  
  // Smooth Scrolling for Navigation
  function initSmoothScrolling() {
    const navLinks = document.querySelectorAll('a[href^="#"]');
    
    navLinks.forEach(link => {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        
        const targetId = this.getAttribute('href');
        const targetElement = document.querySelector(targetId);
        
        if (targetElement) {
          const headerHeight = document.querySelector('.header')?.offsetHeight || 0;
          const targetPosition = targetElement.offsetTop - headerHeight;
          
          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
          });
        }
      });
    });
  }
  
  // Language Switcher
  function initLanguageSwitcher() {
    const languageSelector = document.getElementById('language-selector');
    
    if (languageSelector) {
      languageSelector.addEventListener('change', function() {
        const selectedLanguage = this.value;
        
        // Store language preference
        localStorage.setItem('preferred-language', selectedLanguage);
        
        // Update page content based on language
        updateLanguageContent(selectedLanguage);
        
        // Update URL if needed
        updateURL(selectedLanguage);
      });
      
      // Load saved language preference
      const savedLanguage = localStorage.getItem('preferred-language') || 'en';
      languageSelector.value = savedLanguage;
      updateLanguageContent(savedLanguage);
    }
  }
  
  function updateLanguageContent(language) {
    // This would typically make AJAX calls to get translated content
    // For now, we'll just log the language change
    console.log('Language changed to:', language);
    
    // Update meta tags
    document.documentElement.lang = language;
    
    // Update page title if needed
    const titles = {
      en: 'Premium Supply Chain Solutions',
      uk: 'Преміум послуги цифрового маркетингу',
      ru: 'Премиум услуги цифрового маркетинга'
    };
    
    if (titles[language]) {
      document.title = titles[language];
    }
  }
  
  function updateURL(language) {
    const currentPath = window.location.pathname;
    const newPath = `/${language}${currentPath}`;
    
    // Update URL without page reload
    window.history.pushState({}, '', newPath);
  }
  
  // Form Validation
  function initFormValidation() {
    const forms = document.querySelectorAll('form');
    
    forms.forEach(form => {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        
        if (validateForm(this)) {
          submitForm(this);
        }
      });
      
      // Real-time validation
      const inputs = form.querySelectorAll('input, textarea, select');
      inputs.forEach(input => {
        input.addEventListener('blur', function() {
          validateField(this);
        });
        
        input.addEventListener('input', function() {
          clearFieldError(this);
        });
      });
    });
  }
  
  function validateForm(form) {
    const inputs = form.querySelectorAll('input[required], textarea[required], select[required]');
    let isValid = true;
    
    inputs.forEach(input => {
      if (!validateField(input)) {
        isValid = false;
      }
    });
    
    return isValid;
  }
  
  function validateField(field) {
    const value = field.value.trim();
    const type = field.type;
    const required = field.hasAttribute('required');
    
    clearFieldError(field);
    
    if (required && !value) {
      showFieldError(field, 'This field is required');
      return false;
    }
    
    if (type === 'email' && value) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(value)) {
        showFieldError(field, 'Please enter a valid email address');
        return false;
      }
    }
    
    if (type === 'tel' && value) {
      const phoneRegex = /^[\+]?[1-9][\d]{0,15}$/;
      if (!phoneRegex.test(value.replace(/\s/g, ''))) {
        showFieldError(field, 'Please enter a valid phone number');
        return false;
      }
    }
    
    return true;
  }
  
  function showFieldError(field, message) {
    field.classList.add('error');
    
    let errorElement = field.parentNode.querySelector('.field-error');
    if (!errorElement) {
      errorElement = document.createElement('div');
      errorElement.className = 'field-error';
      errorElement.style.color = '#ef4444';
      errorElement.style.fontSize = '0.8rem';
      errorElement.style.marginTop = '0.25rem';
      field.parentNode.appendChild(errorElement);
    }
    
    errorElement.textContent = message;
  }
  
  function clearFieldError(field) {
    field.classList.remove('error');
    const errorElement = field.parentNode.querySelector('.field-error');
    if (errorElement) {
      errorElement.remove();
    }
  }
  
  function submitForm(form) {
    const formData = new FormData(form);
    const data = Object.fromEntries(formData);
    
    // Show loading state
    const submitBtn = form.querySelector('button[type="submit"]');
    const originalText = submitBtn.textContent;
    submitBtn.textContent = 'Sending...';
    submitBtn.disabled = true;
    
    // Simulate form submission
    // In a real implementation, this would make an AJAX call to Shopify
    setTimeout(() => {
      showFormMessage(form, 'Thank you! We\'ll get back to you soon.', 'success');
      form.reset();
      submitBtn.textContent = originalText;
      submitBtn.disabled = false;
    }, 2000);
  }
  
  function showFormMessage(form, message, type) {
    let messageElement = form.querySelector('.form-message');
    if (!messageElement) {
      messageElement = document.createElement('div');
      messageElement.className = 'form-message';
      form.appendChild(messageElement);
    }
    
    messageElement.textContent = message;
    messageElement.className = `form-message ${type}`;
    messageElement.style.display = 'block';
    
    setTimeout(() => {
      messageElement.style.display = 'none';
    }, 5000);
  }
  
  // Lazy Loading
  function initLazyLoading() {
    const images = document.querySelectorAll('img[data-src]');
    
    if ('IntersectionObserver' in window) {
      const imageObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const img = entry.target;
            img.src = img.dataset.src;
            img.classList.remove('lazy');
            imageObserver.unobserve(img);
          }
        });
      });
      
      images.forEach(img => imageObserver.observe(img));
    } else {
      // Fallback for older browsers
      images.forEach(img => {
        img.src = img.dataset.src;
        img.classList.remove('lazy');
      });
    }
  }
  
  // Performance Optimizations
  function initPerformanceOptimizations() {
    // Debounce scroll events
    let scrollTimeout;
    window.addEventListener('scroll', function() {
      if (scrollTimeout) {
        clearTimeout(scrollTimeout);
      }
      scrollTimeout = setTimeout(handleScroll, 10);
    });
    
    // Throttle resize events
    let resizeTimeout;
    window.addEventListener('resize', function() {
      if (resizeTimeout) {
        clearTimeout(resizeTimeout);
      }
      resizeTimeout = setTimeout(handleResize, 100);
    });
    
    // Preload critical resources
    preloadCriticalResources();
  }
  
  function handleScroll() {
    // Header scroll effect
    const header = document.querySelector('.header');
    if (header) {
      if (window.scrollY > 100) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    }
    
    // Update progress indicators
    updateProgressIndicators();
  }
  
  function handleResize() {
    // Refresh GSAP ScrollTrigger
    if (typeof gsap !== 'undefined' && gsap.ScrollTrigger) {
      gsap.ScrollTrigger.refresh();
    }
    
    // Recalculate layouts if needed
    recalculateLayouts();
  }
  
  function updateProgressIndicators() {
    const progressBars = document.querySelectorAll('.progress-bar');
    progressBars.forEach(bar => {
      const section = bar.closest('section');
      if (section) {
        const rect = section.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        const progress = Math.max(0, Math.min(100, 
          ((windowHeight - rect.top) / (rect.height + windowHeight)) * 100
        ));
        bar.style.width = `${progress}%`;
      }
    });
  }
  
  function recalculateLayouts() {
    // Recalculate any custom layouts
    const grids = document.querySelectorAll('.services__grid, .about__content');
    grids.forEach(grid => {
      // Trigger layout recalculation if needed
      grid.style.display = 'none';
      grid.offsetHeight; // Force reflow
      grid.style.display = '';
    });
  }
  
  function preloadCriticalResources() {
    // Preload critical images
    const criticalImages = [
      // Add critical image URLs here
    ];
    
    criticalImages.forEach(src => {
      const link = document.createElement('link');
      link.rel = 'preload';
      link.as = 'image';
      link.href = src;
      document.head.appendChild(link);
    });
    
    // Preload critical fonts
    const criticalFonts = [
      'https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700;900&display=swap'
    ];
    
    criticalFonts.forEach(href => {
      const link = document.createElement('link');
      link.rel = 'preload';
      link.as = 'style';
      link.href = href;
      document.head.appendChild(link);
    });
  }
  
  // Utility Functions
  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
  
  function throttle(func, limit) {
    let inThrottle;
    return function() {
      const args = arguments;
      const context = this;
      if (!inThrottle) {
        func.apply(context, args);
        inThrottle = true;
        setTimeout(() => inThrottle = false, limit);
      }
    };
  }
  
  // Error Handling
  window.addEventListener('error', function(e) {
    console.error('JavaScript error:', e.error);
    // In production, you might want to send this to an error tracking service
  });
  
  // Unhandled Promise Rejections
  window.addEventListener('unhandledrejection', function(e) {
    console.error('Unhandled promise rejection:', e.reason);
    // In production, you might want to send this to an error tracking service
  });
  
  // Service Worker Registration (for PWA features)
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', function() {
      navigator.serviceWorker.register('/sw.js')
        .then(function(registration) {
          console.log('ServiceWorker registration successful');
        })
        .catch(function(err) {
          console.log('ServiceWorker registration failed');
        });
    });
  }
  
  // Analytics and Tracking
  function initAnalytics() {
    // Initialize analytics tracking
    // This would typically include Google Analytics, Facebook Pixel, etc.
    
    // Track page views
    trackPageView();
    
    // Track form submissions
    const forms = document.querySelectorAll('form');
    forms.forEach(form => {
      form.addEventListener('submit', function() {
        trackEvent('form_submission', {
          form_id: form.id || 'contact_form',
          form_action: form.action || 'contact'
        });
      });
    });
    
    // Track button clicks
    const buttons = document.querySelectorAll('.btn, .hero__cta, .service-card__cta');
    buttons.forEach(button => {
      button.addEventListener('click', function() {
        trackEvent('button_click', {
          button_text: this.textContent.trim(),
          button_class: this.className
        });
      });
    });
  }
  
  function trackPageView() {
    // Track page view
    console.log('Page view tracked');
  }
  
  function trackEvent(eventName, eventData) {
    // Track custom events
    console.log('Event tracked:', eventName, eventData);
  }
  
  // Initialize analytics
  initAnalytics();
  
  console.log('Premium Marketing Theme initialized successfully!');
});


